
import React, { useEffect, useState, useRef } from "react";
import CustomError from "../../../utils/customError";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeFirstLetter, getAddonPrice, getSelectedAddons, selectAddon } from "../../../utils/commonfunction";
import {

  CONSUMPTION_TAX_RATES, CURRENCY_SYMBOL, ORDER_PLATFORM,
  ORDER_TYPES, SWAL_SETTINGS,

} from "../../../utils/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import {

  getSessionKey, getSubTotalQRApp, getTranslatedKey,
  handleServerValidations, pluralText, showPrice,

} from "../../../utils/commonfunction";
import Swal from "sweetalert2";
import trash from "../../../assets/restaurant/images/trash.svg";
import { useTranslation } from "react-i18next";
import { createOrder, detail } from "../services/restaurant.order.service";
import { SetCartLength } from "../../../redux/slices/qrcodeDetails";
import * as $ from "jquery";

export default function ReviewOrder() {
  const queryParams = new URLSearchParams(window.location.search);
  const restaurant_id = queryParams.get("restaurant_id");
  const table_id = queryParams.get("table_id");
  const tableDetails = useSelector((state) => {
    return state.QrOrderToken.tableDetails;
  });
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const addNote = useRef();
  const editModifiersFormCloseButton = useRef();
  const editModifiersFormOpenButton = useRef();
  const noteFieldElement = useRef();
  const addNoteClose = useRef();
  const [token] = useState(getSessionKey("qr_user_token"));
  const order_id = queryParams.get("order_id")
    ? queryParams.get("order_id")
    : null;
  const ChargeSettings = useSelector((state) => {
    return state.QrOrderToken.ChargeSettings;
  });
  const [pricing, setPricing] = useState({
    subtotal: 0,
    tax_price: 0,
    grand_total: 0,
    service_charge: 0,
    grand_cost_price: 0
  });

  const dispatch = useDispatch();
  const base = queryParams.get("base");
  const staff_id = queryParams.get('staff_id')
  useEffect(() => {
    if (tableDetails && tableDetails?.capacity) {
      let i = 1;
      const numberOfPersonOptionsTemp = [];
      for (i; i <= tableDetails?.capacity; i++) {
        numberOfPersonOptionsTemp.push(i);
      }
    }
  }, [tableDetails]);

  const mapSelectedItems = (items) => {
    const data = [...items];
    if (data && data.length) {
      data.forEach((item) => {
        if (item && item.selectedAddons?.length) {
          item.addons = item.selectedAddons;
        } else {
          item.addons = [];
        }
      });
      sessionStorage.setItem("cartItem", JSON.stringify(data));
    }
    return data;
  }
  const addForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      ordered_items: [...(JSON.parse(sessionStorage.getItem("cartItem")) || [])],
      parent_id: order_id || "",
      base: ""
    },
    validationSchema: Yup.object({
      ordered_items: Yup.array().min(1, t("restaurant.message.err_item_required"))
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      let formData = {
        ...values,
        restaurant_id,
        table_id,
        type: order_id ? ORDER_TYPES.SUB_ORDER : ORDER_TYPES.BASE_ORDER,
        tag: values.tag,
        ...(getSubTotalQRApp(values?.ordered_items, ChargeSettings) || {}),
        parent_id: order_id || "",
        base: base,
        staff_id: base === ORDER_PLATFORM.APP ? staff_id : null,
        order_type: 'eat_in'
      };

      // console.log("formData", formData);
      // return false;

      // formData.ordered_items = mapSelectedItems(formData?.ordered_items);
      createOrder(formData, { token: token })
        .then((response) => {
          if (response.success) {
            sessionStorage.removeItem('cartItem');
            if (base === ORDER_PLATFORM.WEB) {
              Swal.fire({
                icon: "success",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
            else {
              const appData = { action: 'show-success', data: handleServerValidations(response) };
              window.ReactNativeWebView?.postMessage(JSON.stringify(appData));

            }

            resetForm();
            dispatch(SetCartLength(0));
            const mySearchParams = new URLSearchParams(window.location.search);
            mySearchParams.set(
              "order_id", response?.data?.orderData?.parent_id ?
              response?.data?.orderData?.parent_id : response?.data?.orderData?._id
            );
            mySearchParams.set("user_name", formData?.customer_name ? formData?.customer_name : "Guest");
            mySearchParams.set("show_language_list", "true");
            if (base === ORDER_PLATFORM.WEB) {
              navigate({
                pathname: `/qr-order/place`,
                search: mySearchParams.toString(),
              });
            }
            else {
              navigate({
                pathname: "/qr-order/success",
                search: mySearchParams.toString(),
              });
            }

          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  useEffect(() => {
    setPricing(
      getSubTotalQRApp(addForm?.values?.ordered_items, ChargeSettings, {
        handleTaxSettings: true,
      })
    );
  }, [addForm?.values?.ordered_items, ChargeSettings]);

  const deleteRecord = (item) => {
    Swal.fire({
      title: t("qr_code.msg_are_you_sure"),
      text: t("qr_code.btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("qr_code.btn_delete"),
      cancelButtonText: t("qr_code.btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {

        let data = [...addForm.values?.ordered_items];
        const index = data?.findIndex((record) => record.preference_id === item?.preference_id);
        if (index !== -1) {
          data.splice(index, 1);
          addForm.setFieldValue("ordered_items", data);
          sessionStorage.setItem("cartItem", JSON.stringify(data))
        }
      }
    });
  };

  const handleChangeQuantity = (item, type, quantity) => {
    let allItems = [...addForm?.values?.ordered_items];
    if (type === "increase") {
      const index = allItems.findIndex(record => record?.preference_id === item?.preference_id);
      allItems[index].quantity += 1;
    } else {
      const index = allItems.findLastIndex((record) => record?.preference_id === item?.preference_id);
      if (index >= 0) {
        if (quantity > 1) {
          allItems[index].quantity -= 1;
        } else {
          allItems.splice(index, 1);
        }
      }
    }
    addForm.setFieldValue("ordered_items", allItems);
    sessionStorage.setItem("cartItem", JSON.stringify(allItems))
  };

  useEffect(() => {
    let result = 0;
    addForm?.values?.ordered_items.forEach((record) => {
      result += record?.quantity;
    });
    dispatch(SetCartLength(result));
  }, [addForm?.values?.ordered_items]);

  const closeAddNote = () => {
    noteForm.resetForm();
    addNote.current.click();
  }
  const handleAddNote = async (item) => {
    noteForm.setFieldValue("itemId", item.preference_id);
    addNote.current.click();
    setTimeout(() => {
      noteFieldElement.current.focus();
    }, 500);
  };
  const noteForm = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    initialValues: {
      notes: "",
      itemId: ""
    },
    validationSchema: Yup.object().shape({
      notes: Yup.string().trim().required("Note is required.")
    }),
    onSubmit(values) {
      let allItems = [...addForm?.values?.ordered_items];
      const index = allItems.findIndex(record => record.preference_id === values.itemId);
      allItems[index].notes = values.notes;
      addForm.setFieldValue("ordered_items", allItems);
      sessionStorage.setItem("cartItem", JSON.stringify(allItems));
      closeAddNote();
    }
  });
  const removeNote = (id) => {
    let allItems = [...addForm?.values?.ordered_items];
    const index = allItems.findIndex(record => record.preference_id === id);
    allItems[index].notes = null;
    addForm.setFieldValue("ordered_items", allItems);
    sessionStorage.setItem("cartItem", JSON.stringify(allItems));
  };

  const toggleDetails = (id) => {
    $(`#${id}`).toggle();
  };

  const editModifiersForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      _id: '',
      type: '',
      image: '',
      price: '',
      addons: [],
      item_name: '',
      tax_price: '',
      cost_price: '',
      addon_price: '',
      total_price: '',
      preference_id: '',
      short_description: '',
      consumption_tax_rate: '',
    },
    onSubmit: (values) => {
      let data = [...addForm?.values?.ordered_items];
      const index = data.findIndex(record => record.preference_id === values.preference_id);
      data[index] = { ...values, addon_price: getAddonPrice(values) };
      addForm.setFieldValue("ordered_items", data);
      sessionStorage.setItem("cartItem", JSON.stringify(data));
      editModifiersFormCloseButton?.current?.click();
      editModifiersForm.resetForm();
    },
  });



  const handleEditModifiers = (item) => {
    editModifiersForm.setValues({ ...item });
    editModifiersFormOpenButton?.current?.click();
  };

  return (
    <>
      <form className="form-flex-layout" style={{ background: 'white' }} onSubmit={addForm.handleSubmit}>
        <div className="qr-body-wrap">
          <div className="p-3">
            {addForm?.values?.ordered_items?.length ? (
              <div className="items-edit-delete">
                <h4>Items</h4>
                <div className="d-flex gap-2 flex-column">
                  {addForm?.values?.ordered_items?.map(
                    (item, index) => {
                      return (
                        <div className="card user-select-none" key={index}>
                          <div className="p-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="cp" onClick={() => { toggleDetails(item.preference_id) }} >
                                <span className="d-block">
                                  {getTranslatedKey("item_name", item)}{" "}
                                  <br />
                                </span>

                              </div>
                              <div className="border border-1 rounded-1 quantity-box d-flex justify-content-between mb-0 w-fit">
                                <button className="btn btn-sm py-1 px-2 h-auto" type="button" onClick={() => {
                                  handleChangeQuantity(item, "decrease", item?.quantity);
                                }}
                                >
                                  <i className="ti ti-minus"></i>
                                </button>
                                <span className="d-flex align-items-center">
                                  {item?.quantity}
                                </span>
                                <button
                                  className="btn btn-sm py-1 px-2 h-auto"
                                  type="button"
                                  onClick={() => {
                                    handleChangeQuantity(item, "increase", item?.quantity);
                                  }}
                                >
                                  <i className="ti ti-plus"></i>
                                </button>
                              </div>
                              <div>
                                <div className="d-flex gap-2">
                                  <div className="d-flex align-items-center">
                                    <span>
                                      {showPrice((item?.price + (item?.addon_price || 0)) * item?.quantity)}
                                    </span>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      deleteRecord(item);
                                    }}
                                    className="btn btn-icon btn-danger  btn-sm h-auto py-2"
                                  >
                                    <i className="ti ti-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id={item.preference_id} style={{ display: 'none' }} className="p-3 pt-0">
                            <div>
                              {
                                item?.addons?.length ?
                                  <div className="modifiers-view">
                                    <span className="d-block text-primary cp" onClick={() => { handleEditModifiers(item) }}>Edit modifiers</span>
                                    {
                                      getSelectedAddons(item)?.map((addon, index) => {
                                        return <span className="d-block" key={index}>{addon?.item_name}</span>;
                                      })
                                    }
                                  </div>
                                  : null
                              }
                              {item?.notes ?
                                <>
                                  <span className="d-block mb-2">{item?.notes}</span>
                                  <div
                                    className="btn2 d-inline-block"
                                  >
                                    <svg
                                      width={19}
                                      height={19}
                                      className="me-2"
                                      viewBox="0 0 13 13"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M10.8332 4.46867V9.74992C10.8332 11.3749 9.86359 11.9166 8.6665 11.9166H4.33317C3.13609 11.9166 2.1665 11.3749 2.1665 9.74992V4.46867C2.1665 2.70825 3.13609 2.302 4.33317 2.302C4.33317 2.63784 4.46857 2.94117 4.69066 3.16325C4.91274 3.38533 5.21609 3.52075 5.55192 3.52075H7.44775C8.11942 3.52075 8.6665 2.97367 8.6665 2.302C9.86359 2.302 10.8332 2.70825 10.8332 4.46867Z"
                                        stroke="#E42375"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M8.66683 2.302C8.66683 2.97367 8.11975 3.52075 7.44808 3.52075H5.55225C5.21641 3.52075 4.91306 3.38533 4.69098 3.16325C4.4689 2.94117 4.3335 2.63784 4.3335 2.302C4.3335 1.63034 4.88058 1.08325 5.55225 1.08325H7.44808C7.78391 1.08325 8.08726 1.21867 8.30934 1.44075C8.53143 1.66284 8.66683 1.96617 8.66683 2.302Z"
                                        stroke="#E42375"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.3335 7.04175H6.50016"
                                        stroke="#E42375"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M4.3335 9.20825H8.66683"
                                        stroke="#E42375"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <svg
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg" className="cp"
                                      onClick={() => {
                                        removeNote(item.preference_id);
                                      }}
                                    >
                                      <path
                                        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                        stroke="#E42375"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M9.16992 14.8299L14.8299 9.16992"
                                        stroke="#E42375"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M14.8299 14.8299L9.16992 9.16992"
                                        stroke="#E42375"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </>
                                :
                                <button
                                  type="button"
                                  onClick={() => {
                                    handleAddNote(item);
                                  }}
                                  className="btn2"
                                >
                                  <svg
                                    width={19}
                                    height={19}
                                    className="me-2"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.8332 4.46867V9.74992C10.8332 11.3749 9.86359 11.9166 8.6665 11.9166H4.33317C3.13609 11.9166 2.1665 11.3749 2.1665 9.74992V4.46867C2.1665 2.70825 3.13609 2.302 4.33317 2.302C4.33317 2.63784 4.46857 2.94117 4.69066 3.16325C4.91274 3.38533 5.21609 3.52075 5.55192 3.52075H7.44775C8.11942 3.52075 8.6665 2.97367 8.6665 2.302C9.86359 2.302 10.8332 2.70825 10.8332 4.46867Z"
                                      stroke="#E42375"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M8.66683 2.302C8.66683 2.97367 8.11975 3.52075 7.44808 3.52075H5.55225C5.21641 3.52075 4.91306 3.38533 4.69098 3.16325C4.4689 2.94117 4.3335 2.63784 4.3335 2.302C4.3335 1.63034 4.88058 1.08325 5.55225 1.08325H7.44808C7.78391 1.08325 8.08726 1.21867 8.30934 1.44075C8.53143 1.66284 8.66683 1.96617 8.66683 2.302Z"
                                      stroke="#E42375"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M4.3335 7.04175H6.50016"
                                      stroke="#E42375"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M4.3335 9.20825H8.66683"
                                      stroke="#E42375"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  Add Note
                                </button>
                              }

                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
                <button
                  className="btn btn-primary w-100 mt-4"
                  type="button"
                  onClick={() => {
                    const searchParams = location.search;
                    navigate(`/qr-order${searchParams}`);
                  }}
                >
                  Want to add more items?
                </button>
              </div>
            ) : (
              <div className="items-edit-delete">
                <h4>{t("qr_code.no_order_text")}</h4>
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => {
                    const searchParams = location.search;
                    navigate(`/qr-order${searchParams}`);
                  }}
                >
                  {t("qr_code.select_item_label")}
                </button>
                <CustomError
                  className="text-danger"
                  name="ordered_items"
                  form={addForm}
                />
              </div>
            )}
          </div>
        </div>
        <div className="cart-bottom p-3">
          {/* Showing the pricing breakdown for selected items */}
          {addForm?.values?.ordered_items?.length ? (
            <div className="info-order-review">
              <table width={"100%"}>
                <tbody>
                  <tr>
                    <td>
                      Subtotal (
                      {addForm?.values?.ordered_items?.length}{" "}
                      {pluralText(
                        addForm?.values?.ordered_items?.length,
                        "Item",
                        "Items"
                      )}
                      )
                    </td>
                    <td className="text-end">
                      {CURRENCY_SYMBOL} {showPrice(pricing?.subtotal)
                      }
                    </td>
                  </tr>

                  {pricing?.service_charge ? (
                    <tr>
                      <td>Service Charge ({ChargeSettings?.service_charge}%)</td>
                      <td className="text-end">
                        {CURRENCY_SYMBOL} {showPrice(pricing?.service_charge)}
                      </td>
                    </tr>
                  ) : null}

                  {pricing?.tax_price ? (
                    <tr>
                      <td>VAT</td>
                      <td className="text-end">
                        {CURRENCY_SYMBOL} {showPrice(pricing?.tax_price)}
                      </td>
                    </tr>
                  ) : null}

                  <tr>
                    <td>
                      <h3>Total</h3>
                    </td>
                    <td className="text-end">
                      <h3>{CURRENCY_SYMBOL} {showPrice(pricing?.grand_total)}</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : null}
          <button className="btn btn-primary w-100" type="submit">
            {t("Place Order")}
          </button>
        </div>
      </form>

      <button
        className="btn btn-dark w-100 mt-2 d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal2"
        id="increaseQuantity"
      ></button>

      {/* Add Note Modal */}
      <button className="btn btn-sm btn-primary d-none" ref={addNote} data-bs-toggle="offcanvas" data-bs-target="#addNote" aria-controls="addNoteCanvasLabel"></button>
      <div className="offcanvas offcanvas-bottom qr-offcanvas" data-bs-backdrop="static" tabIndex="-1" id="addNote" aria-labelledby="addNoteCanvasLabel">
        <div className="offcanvas-header">
          <h3 className="offcanvas-title">Add Note</h3>
          <button onClick={closeAddNote} type="button" className="btn-close" ref={addNoteClose}></button>
        </div>

        <div className="offcanvas-body small">
          <textarea className="form-control" autoComplete="off" style={{ height: "100px" }}
            name="notes" onBlur={noteForm.handleBlur}
            value={noteForm?.values?.notes} onChange={noteForm.handleChange}
            placeholder="Please enter your note here..." ref={noteFieldElement}></textarea>
          <CustomError name="notes" form={noteForm} className="text-danger" />
          <button type="button" className="btn btn-primary save-button-addon" onClick={noteForm.handleSubmit} >Save</button>
        </div>
      </div>

      {/* Edit modifiers canvas */}
      <div className="offcanvas offcanvas-bottom qr-offcanvas canvas-radius overflow-hidden" data-bs-backdrop="static" tabIndex="-1" id="itemModifyCanvas" aria-labelledby="itemModifyCanvasLabel">
        <div className="offcanvas-header pb-0">
          <h3 className="offcanvas-title" id="itemModifyCanvasLabel">
            {getTranslatedKey('item_name', editModifiersForm?.values)}
          </h3>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            ref={editModifiersFormCloseButton}
          ></button>
        </div>

        <button className="btn btn-sm btn-primary d-none" ref={editModifiersFormOpenButton} data-bs-toggle="offcanvas" data-bs-target="#itemModifyCanvas" aria-controls="itemModifyCanvas"></button>
        <div className="offcanvas-body small">
          {editModifiersForm?.values?.short_description && <p className="mb-4" style={{ fontSize: '14px' }}>{editModifiersForm.values.short_description}</p>}
          <form onSubmit={editModifiersForm.handleSubmit}>
            {editModifiersForm?.values && editModifiersForm?.values?._id && (
              <>
                <div className="">
                  {editModifiersForm?.values?.addons?.length > 0 ? (
                    editModifiersForm.values.addons.map((addon, index) => {
                      return (
                        <div key={index} className={(index + 1 < editModifiersForm?.values?.addons?.length ? "mb-4" : "")}>
                          <h3 className="mb-2">
                            {getTranslatedKey("addon_name", addon)}
                          </h3>
                          <div className="d-flex flex-wrap gap-2">
                            {addon?.assigned_items?.map((option, opIndex) => {
                              return (
                                <label htmlFor={option?._id} className='item-type-checkbox' key={opIndex}>
                                  <input id={option?._id} name={addon?.addon_id} type="radio" checked={option?.selected} onChange={() => { selectAddon(editModifiersForm, addon, option) }} value={addon.addon_id} />
                                  <span className='label'>
                                    {capitalizeFirstLetter(option.item_name)} {option?.item_price > 0 ? ` + ${CURRENCY_SYMBOL} ${option?.item_price}` : ""}
                                  </span>
                                </label>
                                
                              );
                            })}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div>
                      <h4 className="mb-2">Options</h4>
                      <button type="button" className="btn border px-3 py-2 btn-primary modifier-option active">
                        General
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

            <button className="btn btn-primary w-100 mt-4" type="submit">Update</button>
          </form>
        </div>
      </div>
    </>
  );
}